/* eslint-disable @typescript-eslint/no-explicit-any */
import { createMemo, createRoot } from "solid-js";
import { createStore } from "solid-js/store";

import {
  useGetAgentDetails,
  useGetAllAgentConfig,
} from "@/api/clientApi/activity";
import { useGetUserShareUrl } from "@/api/clientApi/user";
import {
  useAgencyRewardList,
  useAgencySummary,
  useCommissionDetailList,
  useDoAgentActive,
  useFriendVipList,
  useGetAgencyDayCommissionRecord,
  useGetAgencyRewardDetail,
  useGetAgentShareConfig,
  useGetAppSentRewardAmountAnd40UserGotRecord,
  useGetPidInfo,
  useGetUserStatCombineForAgentActivity,
  useLockedUserList,
  useReceiveAgencyReward,
  useTeamCommissionData,
} from "@/api/clientApi/userAgent";
import { DialogType } from "@/components/Dialogs/types";
import { useDialog } from "@/components/Dialogs/useDialog";
import { LocalStorageKey } from "@/constants/constants";
import { getContentByLang, t } from "@/i18n";
import { pubSub } from "@/lib/PubSub";
import { getDecString } from "@/lib/aesUtils";
import { formatDate } from "@/lib/dateUtils";
import { copyText, urlAddParam } from "@/lib/helper";
import { setLocalStorageItem } from "@/lib/localStorage";
import { formatToBindPoint } from "@/lib/pointUtils";
import { sdkManager } from "@/lib/sdk/sdkManager";
import { getAppType, getOS, toOutLink } from "@/lib/utils";
import { PubSubEvents } from "@/types/PubSub";
import {
  ActivityTypeEnum,
  AgentActivityTypeEnum,
} from "@/types/compontent/base/baseEnum";
import { TeamAgentAllConfig } from "@/types/swagger/activity";
import {
  AgencyDayCommissionRecord,
  AgencyDayCommissionRecordReq,
  AgencyFriendVipReq,
  AgencyLockUserInfo,
  AgencyLockUserReq,
  AgencyReceiveRewardReq,
  AgencyRewardInfo,
  AgencyRewardListReq,
  AgencyRewardRsp,
  AgencyVipInfo,
  GetAppSentRewardAmountAnd40UserGotRecordResp,
  GetUserGotRecordItem,
} from "@/types/swagger/userAgent";

import { getActivityCfg, getActivityState } from "./activityStore";
import { appName, configStore } from "./configStore";
import { sysConfigStore } from "./sysConfigStore";
import { getAgentRewardDotData, userStore } from "./userStore";

export interface AffiliateTabItem {
  value: string;
  text: string;
  icon: string;
  showRedDot?: boolean;
}

export interface AffiliateStore {
  teamAgentAllConfig: TeamAgentAllConfig;
  teamAgentDetails: {
    activity_status: number;
    details: {
      game_rebate_details: {
        level: number;
        vaild_invite: number;
        day_flow: number;
        expected_bonus: number;
      };
      invite_box_details: {
        valid_people_count: number;
        rec_box_id: number[];
        recd_box_id: number[];
      };
      invite_details: {
        friend_reward: object;
        invite_friends_rewards: object[];
        today_received_times: number;
        config_times: number;
        total_reward_point: number;
        total_pay_point: number;
        total_flow_point: number;
        received_invited_reward: boolean;
      };
      received_rewards_record: object[];
    };
    details_status: {
      status: number;
      countdown: number;
      un_lock_lv: number;
    };
    rewards: {
      history_reward_point: number;
      count: number;
      list: object[];
    };
  };
  activeTeamLevel: number;
  activeTeamSlide: number;
  record: GetAppSentRewardAmountAnd40UserGotRecordResp;

  referralHistoryType: number;
  referralHistoryType2: number;
  referralReceived: {
    date: string;
    typeList: Array<{
      type: number;
      name: string;
    }>;
    params: {
      stime: string;
      etime: string;
      type: number;
      page: number;
      limit: number;
    };
    list: Array<AgencyDayCommissionRecord>;
    finish: boolean;
    loading: boolean;

    hisParams: {
      stime: string;
      etime: string;
      type: number;
      page: number;
      limit: number;
    };
    hisList: Array<AgencyDayCommissionRecord>;
    hisFinish: boolean;
    hisLoading: boolean;
  };
  referralWithdraw: {
    date: string;
    typeList: Array<AgencyRewardInfo>;
    params: {
      stime: string;
      etime: string;
      page: number;
      limit: number;
    };
    list: Array<AgencyRewardInfo>;
    finish: boolean;
    loading: boolean;

    hisParams: {
      stime: string;
      etime: string;
      page: number;
      limit: number;
    };
    hisList: Array<AgencyRewardInfo>;
    hisFinish: boolean;
    hisLoading: boolean;
  };
  lockedReward: {
    params: {
      page: number;
      limit: number;
    };
    list: Array<AgencyRewardInfo>;
    finish: boolean;
    loading: boolean;
  };
  lockedVipReward: {
    params: {
      page: number;
      limit: number;
    };
    list: Array<AgencyVipInfo>;
    finish: boolean;
    loading: boolean;
  };
  inQueue: boolean;
}

export const [affiliateStore, setAffiliateStore] = createStore({
  shareLink: "",
  code: "",
  tabActive: "",
  teamAgentAllConfig: {
    atype: 0, //活动id
    cfg: {
      agent_cfg: {},
      invite_box_config: {
        status: 0, //邀请宝箱状态 1 开启 其它关闭
        items: [],
      }, //邀请宝箱配置
      invite_config: {
        status: 0, //邀请状态 1 开启 其它关闭
        invite_reward: {
          point: 0,
        },
        invited_rewards: [],
        invited_reward: {
          point: 0,
        },
        reward_times: 0,
      }, //邀请奖金配置
      team_rebate_config: {
        items: [],
        game_class: [],
      }, //团队返佣配置
    },
    rules: {}, //规则
  },
  teamAgentDetails: {
    activity_status: 0, //活动状态 1 开启 其它关闭
    details: {
      game_rebate_details: {
        level: 0, //当前等级
        vaild_invite: 0, //有效会员人数
        day_flow: 0, //日流水
        expected_bonus: 0, //预期今日佣金
      },
      invite_box_details: {
        valid_people_count: 0, //有效邀请人数
        rec_box_id: [] as string[], //可以领取的宝箱id
        recd_box_id: [] as string[], //已经领取的宝箱id
      },
      invite_details: {
        friend_reward: null, // 邀请奖励
        invite_friends_rewards: [], //邀请奖励
        today_received_times: 0, //今日领取次数
        config_times: 0, //今日可邀请人数
        total_reward_point: 0, //邀请奖励总额
        total_pay_point: 0, //总充值额
        total_flow_point: 0, //总流水额
        received_invited_reward: false,
      },
      received_rewards_record: [], //已经领取的奖励
    },
    details_status: {
      status: 0,
      countdown: 0,
      un_lock_lv: 0,
    },
    rewards: {
      history_reward_point: 0, //历史奖励数据
      count: 0, //数量
      list: [], //佣金列表
    },
  },
  referralHistoryType: 1,
  referralHistoryType2: 1,
  activeTeamLevel: 0,
  activeTeamSlide: 0,
  record: {} as GetAppSentRewardAmountAnd40UserGotRecordResp,
  summaryData: {
    level_one_invites: 0, //一级邀请人数
    level_one_vaild_invites: 0, //一级有效邀请人数
    today_level_one_invites: 0, //今日一级邀请人数
    total_invites: 0, //总邀请人数
    total_commission: 0, //总佣金
    today_child_first_recharge_count: 0, //当日一级下级首充人数
    child_has_recharged_count: 0, //一级下级充值总人数
    child_has_bet_amount_point: 0, //一级下级投注总额
    today_child_bet_amount_point: 0, //当日一级下级有效投注
  },
  //代理数据
  referActivity: {
    hide: false,
    team_total: 0,
    user_reward_point_for_agent_activity: {
      all_received_point: 0,
      un_receive_all_point: 0, //未领取合计
      un_receive_for_33_and_35_point: 0, //未领取33和35活动合计奖金
      un_receive_for_36_point: 0, //未领取36活动奖金
      un_receive_for_37_point: 0, //未领取37活动奖金
      un_receive_for_38_point: 0, //未领取38活动奖金
      un_receive_reward_map: {
        [ActivityTypeEnum.inviteUsers]: 0,
        [ActivityTypeEnum.inviteUsersVip]: 0,
        [ActivityTypeEnum.disRecharge3]: 0,
        [ActivityTypeEnum.proxyAward]: 0,
        [ActivityTypeEnum.proxyAward2]: 0,
        [ActivityTypeEnum.unlimitedProxy]: 0,
      },
    },
    user_stat_for_agent_activity: {
      today_child_register_count: 0, //当日一级下级注册人数
      today_child_first_recharge_count: 0, //当日一级下级首充人数
      today_child_bet_amount_point: 0, //当日一级下级有效投注
      child_count: 0, //一级下级总数
      today_level_one_valid_count: 0, //今日有效下级
      level_one_valid_count: 0, // 有效消极
      child_has_recharged_count: 0, //一级下级充值总人数
      child_has_bet_amount_point: 0, //一级下级投注总额
    },
  },
  agencySummary: {
    total_commission: 0, //历史总佣金
    today_invite_count: 0, //今日邀请人数
    invite_count: 0, //邀请总人数
    today_invite_pay_count: 0, //今日邀请充值人数
    invite_recharge_count: 0, //邀请总充值人数
    today_valid_invite_count: 0, //今日有效邀请人数
    valid_invite_count: 0, //历史有效邀请人数
  },
  teamCommissionData: {
    invite_count: 0, //邀请总人数
    invite_pay_count: 0, //邀请总充值人数
    today_invite_count: 0, //今日邀请人数
    yesterday_invite_count: 0, //昨日邀请人数
    month_invite_count: 0, //本月邀请人数
    today_pay_invite_count: 0, //今日邀请充值人数
    yesterday_pay_invite_count: 0, //昨日邀请充值人数
    month_pay_invite_count: 0, //本月邀请充值人数
    level1_count: 0, //1级人数
    level2_count: 0, //2级人数
    level3_count: 0, //3级人数
  },
  teamCommissionDetails: {
    date: formatDate(new Date().getTime(), 4),
    user_id: "",
    params: {
      stime: "",
      etime: "",
      level: 1,
      user_id: "",
      sort_type: 0,
      sort_value: 1,
      page: 1,
      limit: 10,
    },
    list: [],
    loading: false,
    finish: false,
  },
  pidInfo: {
    head: 0,
    nickname: "",
  },
  rebateValue1: 10000,
  rebateValue2: 10000,
  teamShareConfig: {
    img_config: {},
    text_config: {},
  },
  activeShareText: 0,

  agencyRewardDetail: {
    flow_commission: 0, //佣金
    recharge_commission: 0, //下级充值佣金
    levelup_commission: 0, //升级佣金
    recv_flow_commission: 0, //佣金
    recv_recharge_commission: 0, //下级充值佣金
    locked_invite_user_count: 0, //邀请锁定人数
    locked_levelup_point: 0,
  } as AgencyRewardRsp,
  referralReceived: {
    date: formatDate(new Date().getTime(), 4),
    typeList: [
      {
        type: 0,
        name: "home.all",
        value: 0,
      },
      {
        type: 1,
        name: "affiliate.referral_rewards",
        value: 1,
      },
      {
        type: 2,
        name: "affiliate.commission",
        value: 2,
      },
      {
        type: 3,
        name: "affiliate.depositrebate",
        value: 3,
      },
      {
        type: 4,
        name: "affiliate.level_up_rewards",
        value: 4,
      },
    ],
    params: {
      stime: 0,
      etime: 0,
      type: 0,
      page: 1,
      limit: 10,
    },
    loading: false,
    list: [] as Array<AgencyDayCommissionRecord>,
    finish: false,

    hisParams: {
      stime: 0,
      etime: 0,
      type: 0,
      page: 1,
      limit: 10,
    },
    hisList: [] as Array<AgencyDayCommissionRecord>,
    hisFinish: false,
    hisLoading: false,
  },
  referralWithdraw: {
    date: formatDate(new Date().getTime(), 4),
    params: {
      stime: 0,
      etime: 0,
      page: 1,
      limit: 10,
    },
    loading: false,
    list: [] as Array<AgencyRewardInfo>,
    finish: false,

    hisParams: {
      stime: 0,
      etime: 0,
      page: 1,
      limit: 10,
    },
    hisLoading: false,
    hisList: [] as Array<AgencyRewardInfo>,
    hisFinish: false,
  },
  lockedReward: {
    params: {
      page: 1,
      limit: 10,
    },
    list: [] as Array<AgencyLockUserInfo>,
    finish: false,
    loading: false,
  },
  lockedVipReward: {
    params: {
      page: 1,
      limit: 10,
    },
    list: [] as Array<AgencyVipInfo>,
    finish: false,
    loading: false,
  },
  agentShowCount: false,
  agentFriendShowCount: false,
  inQueue: false,
});

export async function setAgentRewardDotData() {
  const res = await getAgentRewardDotData();
  if (res) {
    setAffiliateStore("agentShowCount", (res?.agent_unread_count ?? 0) > 0);
    setAffiliateStore(
      "agentFriendShowCount",
      (res?.agent_friend_unread_count ?? 0) > 0,
    );
  }
}

export function initTeamAgent(getAllAgentConfigCallback?: () => void) {
  /*Promise.all([
    getAllAgentConfig(),
    getAppSentRewardAmountAnd40UserGotRecord(),
    getUserShareUrl(),
    getShareTextConfig(),
    getUserStatCombineForAgentActivity(),
  ])
    .then(() => {
      if (callback) {
        callback();
      }
    })
    .catch((err) => {
      console.log(err);
      if (callback) {
        callback();
      }
    });*/
  getAllAgentConfig()
    .then(() => {
      if (getAllAgentConfigCallback) {
        getAllAgentConfigCallback();
      }
    })
    .catch(() => {
      if (getAllAgentConfigCallback) {
        getAllAgentConfigCallback();
      }
    });
  getAppSentRewardAmountAnd40UserGotRecord();
  getUserShareUrl();
  getShareTextConfig();
  getUserStatCombineForAgentActivity();
  if (userStore.isLogin) {
    setAgentRewardDotData();
  }
}
export async function getAgencyRewardDetail() {
  const res = await useGetAgencyRewardDetail({});
  if (res) {
    setAffiliateStore("agencyRewardDetail", res);
  }
}

export async function getAppSentRewardAmountAnd40UserGotRecord() {
  const res = await useGetAppSentRewardAmountAnd40UserGotRecord({});
  if (res) {
    res.user_got_reward_list?.forEach((el: GetUserGotRecordItem) => {
      el.vip_level = el.vip_level || 1;
    });
    setAffiliateStore("record", res);
  }
}
export async function getAllAgentConfig() {
  if (!userStore.isLogin) return;
  const res = await useGetAllAgentConfig({
    atypes: [AgentActivityTypeEnum.teamAgent],
  });
  if (res && res.configs) {
    const teamAgent = res.configs[AgentActivityTypeEnum.teamAgent];
    if (teamAgent) {
      const teamAgentAllConfig = {
        ...affiliateStore.teamAgentAllConfig,
        ...teamAgent,
      };
      const rules = teamAgentAllConfig.rules || {};
      for (const key in rules) {
        if (rules[key]) {
          try {
            rules[key] = getDecString(rules[key]);
          } catch (error) {
            console.error(`parse error teamAgent rules:`, error + rules[key]);
          }
        }
      }
      teamAgentAllConfig.rules = rules;
      setAffiliateStore("teamAgentAllConfig", teamAgentAllConfig);
      getAgentDetails();
    }
  }
}
export async function getAgentDetails() {
  const res = await useGetAgentDetails({
    atypes: [AgentActivityTypeEnum.teamAgent],
  });
  if (res && res.activity_details) {
    const teamAgent = res.activity_details[AgentActivityTypeEnum.teamAgent];
    if (teamAgent) {
      const teamAgentDetails = {
        ...affiliateStore.teamAgentDetails,
        ...teamAgent,
      };
      setAffiliateStore(
        "activeTeamLevel",
        teamAgentDetails?.details?.game_rebate_details.level || 0,
      );

      const items =
        affiliateStore.teamAgentAllConfig?.cfg?.team_rebate_config?.items || [];

      if (!affiliateStore.activeTeamSlide) {
        const index = items.findIndex(
          (item: { level: number }) =>
            item.level == affiliateStore.activeTeamLevel,
        );
        setAffiliateStore("activeTeamSlide", index);
      }
      setAffiliateStore("teamAgentDetails", teamAgentDetails);
    }
  }
}
export async function getUserShareUrl() {
  if (!userStore.isLogin) return;
  const res = await useGetUserShareUrl({});
  if (res) {
    setAffiliateStore("shareLink", res.url);
    setAffiliateStore("code", res.code);
  }
}
export function changeTeamSlide(i: number) {
  setAffiliateStore("activeTeamSlide", i);
  const items: { level: number }[] =
    affiliateStore.teamAgentAllConfig.cfg?.team_rebate_config?.items || [];
  const level = items?.[affiliateStore.activeTeamSlide]?.level || 0;
  setAffiliateStore("activeTeamLevel", level);
}
export async function getUserStatCombineForAgentActivity() {
  if (!userStore.isLogin) return;
  const res = await useGetUserStatCombineForAgentActivity({});
  if (res) {
    const referActivity = { ...affiliateStore.referActivity, ...res };
    setAffiliateStore("referActivity", referActivity);
  }
}
export async function getAgencySummary() {
  if (!userStore.isLogin) return;
  const res = await useAgencySummary({});
  if (res) {
    setAffiliateStore("agencySummary", res);
  }
}
export async function getPidInfo(val?: string) {
  const pid = userStore.userInfo?.pid || val;
  if (pid) {
    const res = await useGetPidInfo({ user_id: Number(pid) });
    if (res) {
      setAffiliateStore("pidInfo", res);
    }
  }
}
export async function handleDoAgentActive(
  type: number,
  id: string,
  push: (path: string) => void,
) {
  if (!teamFriendsReward().is_receivable) return;
  const res = await useDoAgentActive({
    a_type: AgentActivityTypeEnum.teamAgent,
    data: {
      act_type: type,
      id,
    },
  });
  if (res) {
    getAgentDetails();
    push("/affiliate");
    useDialog().operateDialog("Reward", true, {
      items: [
        {
          walletType: 0,
          point: inviteeRewardPoint(),
        },
      ],
    });
    // 领取后更新红点信息
    setAgentRewardDotData();
  }
}
export async function openTeamData() {
  sdkManager.tdReportEvent("team_data_detail_click", {});
  const res = await useTeamCommissionData({});
  if (res) {
    setAffiliateStore("teamCommissionData", res);
    useDialog().showDialog({
      type: DialogType.TeamDetails,
    });
  }
}

export function changeReferralReceivedType(
  type: number,
  isHistory: boolean = false,
  isMobile: boolean = false,
) {
  setAffiliateStore(
    "referralReceived",
    isHistory ? "hisParams" : "params",
    "type",
    type,
  );
  if (isMobile) {
    setAffiliateStore("referralReceived", "finish", false);
  }
  if (!isHistory) {
    console.log("getDayCommissionList----->from1", isHistory);
    getDayCommissionList(isHistory, isMobile);
  } else {
    referralReceivedRefresh();
  }
}

export async function DoReceiveAgencyReward() {
  if (!referralRewardsTotal()) return;
  const param = {
    box_ids:
      affiliateStore.teamAgentDetails.details.invite_box_details.rec_box_id ||
      [],
    invite_ids:
      teamAgentInviteFriendsReward().awards?.map((el: any) => el.id) || [],
  };
  const res = await useReceiveAgencyReward(param as AgencyReceiveRewardReq);
  if (res) {
    setLocalStorageItem(
      LocalStorageKey.CurrentReceiveRewardTaskId,
      res?.task_id || "",
    );
    console.error("res", res);
    if (res?.task_id) {
      console.error("res?.task_id", res?.task_id);
      setAffiliateStore("inQueue", true);
    } else {
      setAffiliateStore("inQueue", false);
    }
    getAgencyRewardDetail();
    getAgentDetails();
    const point =
      affiliateStore.agencyRewardDetail.flow_commission +
      affiliateStore.agencyRewardDetail.recharge_commission +
      teamAgentInviteFriendsReward().claimablePoint +
      teamAgentInviteBoxData().claimablePoint +
      affiliateStore.agencyRewardDetail.levelup_commission;
    useDialog().operateDialog("Reward", true, {
      items: [
        {
          walletType: 0,
          point: point,
        },
      ],
    });
    // 领取后更新红点信息
    setAgentRewardDotData();
  }
}

export function openReferralHistory() {
  setAffiliateStore("referralReceived", "hisParams", "type", 0);
  referralReceivedRefresh();
  referralWithdrawRefresh();
}

export function referralReceivedRefresh() {
  setAffiliateStore("referralReceived", "hisParams", "page", 1);
  setAffiliateStore("referralReceived", "hisList", []);
  setAffiliateStore("referralReceived", "hisFinish", false);
  setAffiliateStore("referralReceived", "hisLoading", false);
}

export function referralWithdrawRefresh() {
  setAffiliateStore("referralWithdraw", "hisParams", "page", 1);
  setAffiliateStore("referralWithdraw", "hisList", []);
  setAffiliateStore("referralWithdraw", "hisFinish", false);
  setAffiliateStore("referralWithdraw", "hisLoading", false);
}

export async function getLockedUserList() {
  if (affiliateStore.lockedReward.loading || affiliateStore.lockedReward.finish)
    return;
  try {
    const param: AgencyLockUserReq = {
      ...affiliateStore.lockedReward.params,
    } as AgencyLockUserReq;
    setAffiliateStore("lockedReward", "loading", true);
    const res = await useLockedUserList(param);
    const list = res?.list || [];
    setAffiliateStore("lockedReward", "list", (prev) => [...prev, ...list]);
    if (list.length < param.limit) {
      setAffiliateStore("lockedReward", "finish", true);
    } else {
      setAffiliateStore("lockedReward", "params", "page", (prev) => prev + 1);
    }
  } finally {
    setAffiliateStore("lockedReward", "loading", false);
  }
}
export async function getFriendVipList() {
  if (
    affiliateStore.lockedVipReward.loading ||
    affiliateStore.lockedVipReward.finish
  )
    return;
  try {
    const param: AgencyFriendVipReq = {
      ...affiliateStore.lockedVipReward.params,
    } as AgencyFriendVipReq;
    setAffiliateStore("lockedVipReward", "loading", true);
    const res = await useFriendVipList(param);
    const list = res?.list || [];
    setAffiliateStore("lockedVipReward", "list", (prev) => [...prev, ...list]);
    if (list.length < param.limit) {
      setAffiliateStore("lockedVipReward", "finish", true);
    } else {
      setAffiliateStore(
        "lockedVipReward",
        "params",
        "page",
        (prev) => prev + 1,
      );
    }
  } finally {
    setAffiliateStore("lockedVipReward", "loading", false);
  }
}
export async function getDayCommissionList(
  isHistory: boolean = false,
  isMobile: boolean = false,
) {
  if (!isMobile) {
    if (isHistory) {
      if (
        affiliateStore.referralReceived.hisLoading ||
        affiliateStore.referralReceived.hisFinish
      )
        return;
    } else {
      if (
        affiliateStore.referralReceived.loading ||
        affiliateStore.referralReceived.finish
      )
        return;
    }
  }
  try {
    let param: AgencyDayCommissionRecordReq = isHistory
      ? ({
          ...affiliateStore.referralReceived.hisParams,
        } as AgencyDayCommissionRecordReq)
      : ({} as AgencyDayCommissionRecordReq);

    if (isHistory) {
      param = {
        ...affiliateStore.referralReceived.hisParams,
      } as AgencyDayCommissionRecordReq;
      param.stime =
        new Date(affiliateStore.referralReceived.date + ` 00:00:00`).getTime() /
        1000;
      param.etime = param.stime + 86400 - 1;
    } else {
      param.type = affiliateStore.referralReceived.params.type || 0;
    }
    setAffiliateStore(
      "referralReceived",
      isHistory ? "hisLoading" : "loading",
      true,
    );
    const res = await useGetAgencyDayCommissionRecord(param);
    const list = res?.list || [];
    if (isMobile) {
      setAffiliateStore("referralReceived", "list", list);
      setAffiliateStore("referralReceived", "loading", false);
      return;
    }
    if (
      (param.page as number) * (param.limit as number) >=
      (res?.total ? res.total : (param.limit as number))
    ) {
      setAffiliateStore(
        "referralReceived",
        isHistory ? "hisFinish" : "finish",
        true,
      );
    } else {
      setAffiliateStore(
        "referralReceived",
        isHistory ? "hisParams" : "params",
        "page",
        (prev) => prev + 1,
      );
    }
    setAffiliateStore(
      "referralReceived",
      isHistory ? "hisList" : "list",
      (prev) => (isHistory ? [...prev, ...list] : list),
    );
  } catch (error) {
    console.log("getDayCommissionList----->error", error);
    setAffiliateStore(
      "referralReceived",
      isHistory ? "hisLoading" : "loading",
      false,
    );
  } finally {
    setAffiliateStore(
      "referralReceived",
      isHistory ? "hisLoading" : "loading",
      false,
    );
  }
}

export async function getAgencyRewardList(isHistory: boolean = false) {
  if (isHistory) {
    if (
      affiliateStore.referralWithdraw.hisLoading ||
      affiliateStore.referralWithdraw.hisFinish
    )
      return;
  } else {
    if (
      affiliateStore.referralWithdraw.loading ||
      affiliateStore.referralWithdraw.finish
    )
      return;
  }
  try {
    let param: AgencyRewardListReq = isHistory
      ? ({
          ...affiliateStore.referralWithdraw.hisParams,
        } as AgencyRewardListReq)
      : ({} as AgencyRewardListReq);
    if (isHistory) {
      param = {
        ...affiliateStore.referralWithdraw.hisParams,
      } as AgencyRewardListReq;
      param.stime =
        new Date(affiliateStore.referralWithdraw.date + ` 00:00:00`).getTime() /
        1000;
      param.etime = param.stime + 86400 - 1;
    }
    setAffiliateStore(
      "referralWithdraw",
      isHistory ? "hisLoading" : "loading",
      true,
    );
    const res = await useAgencyRewardList(param);
    const list = res?.list || [];
    if (
      (param.page as number) * (param.limit as number) >=
      (res?.total ? res.total : (param.limit as number))
    ) {
      setAffiliateStore(
        "referralWithdraw",
        isHistory ? "hisFinish" : "finish",
        true,
      );
    } else {
      setAffiliateStore(
        "referralWithdraw",
        isHistory ? "hisParams" : "params",
        "page",
        (prev) => prev + 1,
      );
    }
    setAffiliateStore(
      "referralWithdraw",
      isHistory ? "hisList" : "list",
      (prev) => (isHistory ? [...prev, ...list] : list),
    );
  } catch (error) {
    console.log("getAgencyRewardList----->error", error);
    setAffiliateStore(
      "referralWithdraw",
      isHistory ? "hisLoading" : "loading",
      false,
    );
  } finally {
    setAffiliateStore(
      "referralWithdraw",
      isHistory ? "hisLoading" : "loading",
      false,
    );
  }
}

export function changeReferralHistoryType(
  type: number,
  isHistory: boolean = true,
  isMobile: boolean = false,
) {
  if (!isHistory) {
    setAffiliateStore("referralHistoryType", type);
    if (type == 1) {
      getDayCommissionList(isHistory, isMobile);
    } else {
      getAgencyRewardList(isHistory);
    }
  } else {
    setAffiliateStore("referralHistoryType2", type);
    if (type == 1) {
      referralReceivedRefresh();
    } else {
      referralWithdrawRefresh();
    }
  }
}

export function changeTeamCommissionDetailsLevel(level: number) {
  setAffiliateStore("teamCommissionDetails", "params", "level", level);
  teamCommissionDetailsRefresh();
}
export function changeTeamCommissionDetailsSortValue() {
  setAffiliateStore(
    "teamCommissionDetails",
    "params",
    "sort_value",
    affiliateStore.teamCommissionDetails.params.sort_value == 0 ? 1 : 0,
  );
  teamCommissionDetailsRefresh();
}
export function changeTeamCommissionDetailsSortType(val: number) {
  setAffiliateStore("teamCommissionDetails", "params", "sort_value", 1);
  setAffiliateStore("teamCommissionDetails", "params", "sort_type", val);
  teamCommissionDetailsRefresh();
}
export function changeTeamCommissionDetailsUserId(id: string) {
  if (id?.length >= 6) {
    teamCommissionDetailsRefresh();
  } else if (
    !id?.length &&
    affiliateStore.teamCommissionDetails.user_id != id
  ) {
    teamCommissionDetailsRefresh();
  }
  setAffiliateStore("teamCommissionDetails", "user_id", id);
}
export function teamCommissionDetailsRefresh() {
  setAffiliateStore("teamCommissionDetails", "params", "page", 1);
  setAffiliateStore("teamCommissionDetails", "list", []);
  setAffiliateStore("teamCommissionDetails", "finish", false);
  getCommissionDetailList();
}
export async function getCommissionDetailList() {
  if (
    affiliateStore.teamCommissionDetails.loading ||
    affiliateStore.teamCommissionDetails.finish
  )
    return;
  try {
    setAffiliateStore("teamCommissionDetails", "loading", true);
    const body = JSON.parse(
      JSON.stringify(affiliateStore.teamCommissionDetails.params),
    );
    body.user_id = Number(body.user_id) || 0;
    body.stime =
      new Date(
        affiliateStore.teamCommissionDetails.date + ` 00:00:00`,
      ).getTime() / 1000;
    body.etime = body.stime + 86400 - 1;
    const res = await useCommissionDetailList(body);
    if (res) {
      const list = res.list || [];
      if (list.length === 0 && body.page === 1) {
        setAffiliateStore("teamCommissionDetails", "finish", true);
        return;
      }
      setAffiliateStore("teamCommissionDetails", "list", (prev) => [
        ...prev,
        ...list,
      ]);
      if (list.length < body.limit) {
        setAffiliateStore("teamCommissionDetails", "finish", true);
      } else {
        setAffiliateStore(
          "teamCommissionDetails",
          "params",
          "page",
          (prev) => prev + 1,
        );
      }
    }
  } finally {
    setAffiliateStore("teamCommissionDetails", "loading", false);
  }
}

export function getGclassName(val: string) {
  const gclass_name_map = {
    "10": "Original",
    "1": "Casual",
    "2": "Slots",
    "3": "Live",
    "4": "Sports",
    "5": "Shows",
    "6": "Lottery",
  } as Record<string, string>;
  return gclass_name_map[val] || "";
}
export function betSum(level: number) {
  const turnover =
    sysConfigStore.sysConfigData.vip_config?.turnover_rate?.turnover || 0;
  const coin =
    parseFloat(
      (
        (sysConfigStore.sysConfigData.vip_config?.turnover_rate?.coin || 0) /
        100
      ).toFixed(2),
    ) || 1;
  return ((viplevelMaps()[level]?.vip_coin || 0) / 100) * turnover * coin;
}
export function clickShare(
  item: {
    icon: string;
    url?: string;
    name: string;
    appUrl?: string;
    ipatype?: number;
  },
  fixShareUrl?: string,
  isType?: string | boolean,
  source?: string,
) {
  if (item.icon.includes("more")) {
    more();
    return;
  }
  let link = fixShareUrl || shareUrl();
  if (link && !link.startsWith("http")) {
    link = window.location.origin + link;
  }
  if (isType) {
    //兼容其它活动分享参数
    if (isType == "ad_id") {
      // 兼容谷歌包分享链接
      if (link.indexOf("%23%23ad_id%23%23") != -1) {
        link = link.replace("%23%23ad_id%23%23", `${item.ipatype}`);
      } else {
        link = urlAddParam(link, `ad_id=${item.ipatype}`);
      }
    } else {
      // 兼容谷歌包分享链接
      if (link.indexOf("%23%23ipatype%23%23") != -1) {
        link = link.replace("%23%23ipatype%23%23", `${item.ipatype}`);
      } else {
        link = urlAddParam(link, `ipatype=${item.ipatype}`);
      }
    }
  }
  const shareUrlEncode = encodeURIComponent(link);
  const text = shareText();
  const textEncode = encodeURIComponent(text);
  const url = item.url
    .replace("{url}", shareUrlEncode)
    .replace("{text}", textEncode);
  if (item.appUrl) {
    copyText(`${shareUrl}\n${text}`);
    const appUrl = item.appUrl
      .replace("{url}", shareUrlEncode)
      .replace("{text}", textEncode);
    window.location.href = appUrl;
    setTimeout(() => {
      toOutLink(url);
    }, 1500);
    return;
  }
  toOutLink(url);
}
export async function more(url?: string, val?: string, source?: string) {
  const link = url || shareUrl();
  const shareReward = val || "R$100";
  try {
    if (navigator.share) {
      await navigator.share({
        title: t("affiliate.free_receive", { val: shareReward }),
        text: t("affiliate.visit_free_get", { link: link, val: shareReward }),
        url: link,
      });
    }
  } catch (error) {
    console.error("Error More Share:", error);
  }
}
export async function getShareTextConfig() {
  if (!userStore.isLogin) return;
  const res = await useGetAgentShareConfig({});
  if (res) {
    const cfg = { ...affiliateStore.teamShareConfig, ...res };
    setAffiliateStore("teamShareConfig", cfg);
  }
}
export function updateShareModal(val: boolean) {
  if (val) {
    useDialog().showDialog({
      type: DialogType.AffiliateShare,
    });
  } else {
    useDialog().closeDialog(DialogType.AffiliateShare);
  }
}
export function openExplain(val: string) {
  let text = "";
  let title = "";
  if (val == "locked") {
    text = `
      <p>${t("affiliate.how_to_get_subordinates_title")}</p>
      <ul class=" list-outside list-disc pl-[20px]">
        <li>
          ${t("affiliate.method_share_link")}
        </li>
        <li>
          ${t("affiliate.method_share_code")}
        </li>
        <li>
          ${t("affiliate.method_share_qr")}
        </li>
      </ul>
    `;
    title = t("affiliate.invite_friends");
  } else if (val == "deposit") {
    text = `
      <p>${t("affiliate.subordinate_deposit_desc")}</p>
    `;
    title = t("affiliate.deposit_friends");
  } else if (val == "valid") {
    text = `
      <p>${t("affiliate.how_to_become_valid_title")}</p>
      <ul class=" list-outside list-disc pl-[20px]">
        <li>
            ${t("affiliate.valid_step_signup")}
        </li>
        <li>
          ${t("affiliate.valid_step_cumulative_deposit", {
            val: formatToBindPoint({
              value: agentBaseConfig().invite_cfg.min_pay,
            }),
          })}
        </li>
        <li>
          ${t("affiliate.valid_step_cumulative_bet", {
            val: formatToBindPoint({
              value: agentBaseConfig().invite_cfg.min_bet,
            }),
          })}
        </li>
        <li>
          ${t("affiliate.valid_user_result")}
        </li>
      </ul>
    `;
    title = t("affiliate.total_valid_friends");
  }
  useDialog().showDialog({
    type: DialogType.TeamExplain,
    data: { text, title },
  });
}
export async function openInviteePopup() {
  const urlParams: {
    [key: string]: string;
  } = {};
  const urlObj = new URL(window.location.href);
  urlObj.searchParams.forEach((value, key) => {
    urlParams[key] = value;
  });
  if (inviteeRewardPoint() || (!userStore.isLogin && urlParams.ic)) {
    await getPidInfo(urlParams.ic);
    useDialog().showDialog({
      type: DialogType.TeamInvitee,
    });
  } else {
    // 当不满足条件时，需要手动触发 CloseDialog 事件，确保弹窗 queue 执行
    setTimeout(() => {
      pubSub.publish(PubSubEvents.CloseDialog, DialogType.TeamInvitee);
    }, 0);
  }
}

export const {
  inviteConfigData,
  inviteBoxConfigData,
  inviteUsersVipData,
  proxyAwardData,
  proxyAward2Data,
  teamRbateConfigData,
  agentCommissionTotal,
  agentAwardTotal,
  inviteUsersData,
  totalInviteRewards,
  disRecharge3Data,
  agentStyle,
  shareUrl,
  shareCode,
  faqList,
  inviteeRewardPoint,
  tabList,
  // mediaShareList,
  inviteBoxDetailsData,
  teamFriendsReward,
  rebateCalculator,
  contactData,
  agentBaseConfig,
  shareImgList,
  shareTextList,
  shareText,
  referralRewardsTotal,
  teamAgentInviteFriendsReward,
  teamAgentInviteBoxData,
  viplevelMaps,
  isLabelHideAgentActivity,
  isLabelHideAgentData,
} = createRoot(() => {
  const isLabelHideAgentActivity = createMemo(() => {
    return (
      sysConfigStore.sysConfigData.agent_base_config?.hide_activity_labels &&
      sysConfigStore.sysConfigData.agent_base_config?.hide_activity_labels
        .length > 0 &&
      sysConfigStore.sysConfigData.agent_base_config?.hide_activity_labels.some(
        (label) => userStore.userInfo?.labels?.includes(label),
      )
    );
  });

  const isLabelHideAgentData = createMemo(() => {
    return (
      sysConfigStore.sysConfigData.agent_base_config?.hide_data_labels &&
      sysConfigStore.sysConfigData.agent_base_config?.hide_data_labels.length >
        0 &&
      sysConfigStore.sysConfigData.agent_base_config?.hide_data_labels.some(
        (label) => userStore.userInfo?.labels?.includes(label),
      )
    );
  });
  const teamAgentInviteBoxData = createMemo(() => {
    let invitable = 0;
    let claimablePoint = 0;
    let invitee = 0;
    let receivePoint = 0;
    let point = 0;
    const items =
      affiliateStore.teamAgentAllConfig.cfg.invite_box_config?.items || [];
    const recdBoxs =
      affiliateStore.teamAgentDetails.details.invite_box_details.recd_box_id ||
      [];
    const recBoxs =
      affiliateStore.teamAgentDetails.details.invite_box_details.rec_box_id ||
      [];
    for (let i = 0; i < items.length; i++) {
      if (recdBoxs.indexOf(items[i].id) != -1) {
        receivePoint += items[i].reward.point || 0;
        invitee = items[i].count > invitee ? items[i].count : invitee;
      } else if (recBoxs.indexOf(items[i].id) != -1) {
        claimablePoint += items[i].reward.point || 0;
        invitee = items[i].count > invitee ? items[i].count : invitee;
      } else {
        point += items[i].reward.point || 0;
      }
      invitable = items[i].count > invitable ? items[i].count : invitable;
    }
    invitable = invitable - invitee;
    return {
      invitable,
      claimablePoint,
      invitee,
      receivePoint,
      point,
    };
  });

  const teamAgentInviteFriendsReward = createMemo(() => {
    const items =
      affiliateStore.teamAgentDetails.details?.invite_details
        ?.invite_friends_rewards || [];
    const awards = items.filter((item: any) => item.is_receivable);
    const claimablePoint = awards.reduce(
      (sum: any, item: any) => sum + (item.reward?.point || 0),
      0,
    );
    return { awards, claimablePoint };
  });

  const referralRewardsTotal = createMemo(() => {
    if (affiliateStore.inQueue) {
      return 0;
    }
    return (
      affiliateStore.agencyRewardDetail.flow_commission +
      affiliateStore.agencyRewardDetail.recharge_commission +
      teamAgentInviteFriendsReward().claimablePoint +
      teamAgentInviteBoxData().claimablePoint +
      affiliateStore.agencyRewardDetail.levelup_commission
    );
  });
  const inviteConfigData = createMemo(() => {
    if (affiliateStore.teamAgentAllConfig.cfg?.invite_config?.status == 1) {
      const point =
        affiliateStore.teamAgentAllConfig.cfg?.invite_config?.invite_reward
          ?.point || 0;

      const invited_reward =
        affiliateStore.teamAgentAllConfig.cfg?.invite_config?.invited_reward
          ?.point || 0;
      return { point, point_rang: invited_reward, min_point: invited_reward };
    }
    return { point: 0, point_rang: 0, min_point: 0 };
  });
  const inviteBoxConfigData = createMemo(() => {
    if (
      affiliateStore.teamAgentAllConfig?.cfg?.invite_box_config?.status == 1
    ) {
      const items =
        affiliateStore.teamAgentAllConfig?.cfg?.invite_box_config?.items || [];
      const total_point = items.reduce(
        (sum: number, item: { reward: { point: number } }) =>
          sum + (item.reward?.point || 0),
        0,
      );
      return { total_point };
    }
    return { total_point: 0 };
  });
  const inviteBoxDetailsData = createMemo(() => {
    let invitable = 0;
    let claimablePoint = 0;
    let invitee = 0;
    let receivePoint = 0;
    let point = 0;
    const items: { count: number; id: number; reward: { point: number } }[] =
      affiliateStore.teamAgentAllConfig.cfg.invite_box_config?.items || [];
    const recdBoxs =
      affiliateStore.teamAgentDetails.details.invite_box_details.recd_box_id ||
      [];
    const recBoxs =
      affiliateStore.teamAgentDetails.details.invite_box_details.rec_box_id ||
      [];
    for (let i = 0; i < items.length; i++) {
      if (recdBoxs.indexOf(items[i].id) != -1) {
        receivePoint += items[i].reward.point || 0;
        invitee = items[i].count > invitee ? items[i].count : invitee;
      } else if (recBoxs.indexOf(items[i].id) != -1) {
        claimablePoint += items[i].reward.point || 0;
        invitee = items[i].count > invitee ? items[i].count : invitee;
      } else {
        point += items[i].reward.point || 0;
      }
      invitable = items[i].count > invitable ? items[i].count : invitable;
    }
    invitable = invitable - invitee;
    return {
      invitable,
      claimablePoint,
      invitee,
      receivePoint,
      point,
    };
  });
  const inviteUsersVipData = createMemo(() => {
    if (getActivityState(ActivityTypeEnum.inviteUsersVip)) {
      const cfgLevels = sysConfigStore.sysConfigData.vip_config?.levels || [];
      let list = [];
      const levels =
        getActivityCfg(ActivityTypeEnum.inviteUsersVip)?.cfg?.levels || [];

      for (const item of cfgLevels) {
        const find = levels.find(
          (level: { vip: number }) => level.vip === item.vip,
        );
        if (find) {
          list.push(find);
        } else if (list.length) {
          let row = list[list.length - 1];
          row = { ...row, vip: item.vip };
          list.push(row);
        }
      }
      list = list.filter((item) => item.reward && item.reward.point);

      const total_point = list.reduce(
        (sum: number, item: { reward: { point: number } }) =>
          sum + (item.reward?.point || 0),
        0,
      );
      return { total_point, list };
    }
    return { total_point: 0, list: [] };
  });
  const proxyAwardData = createMemo(() => {
    if (getActivityState(ActivityTypeEnum.proxyAward)) {
      const list = getActivityCfg(ActivityTypeEnum.proxyAward)?.cfg.list || [];
      const allRewards = list.flatMap(
        (item: { game_class_reward: [] }) => item.game_class_reward || [],
      );
      const max_flow_pro = allRewards.reduce(
        (max: number, rewardItem: { reward: { flow_pro: number } }) => {
          const flowPro = rewardItem.reward?.flow_pro || 0;
          return Math.max(max, flowPro);
        },
        0,
      );
      return { max_flow_pro };
    }
    return { max_flow_pro: 0 };
  });
  const proxyAward2Data = createMemo(() => {
    if (getActivityState(ActivityTypeEnum.proxyAward2)) {
      const list = getActivityCfg(ActivityTypeEnum.proxyAward2)?.cfg.list || [];
      const allRewards = list.flatMap(
        (item: { game_class_reward: [] }) => item.game_class_reward || [],
      );
      const max_flow_pro = allRewards.reduce(
        (max: number, rewardItem: { reward: { flow_pro: number } }) => {
          const flowPro = rewardItem.reward?.flow_pro || 0;
          return Math.max(max, flowPro);
        },
        0,
      );
      return { max_flow_pro };
    }
    return { max_flow_pro: 0 };
  });
  const teamRbateConfigData = createMemo(() => {
    const items =
      affiliateStore.teamAgentAllConfig.cfg.team_rebate_config?.items || [];
    const max_flow_pro = items.reduce(
      (max: number, item: { parent_first_reward: { flow_pro: number } }) => {
        const flowPro = item.parent_first_reward?.flow_pro || 0;
        return Math.max(max, flowPro);
      },
      0,
    );
    const level_map = items.reduce(
      (
        res: Record<
          number,
          { vaild_invite: number; level: number; day_min_flow: number }
        >,
        cur: { vaild_invite: number; level: number; day_min_flow: number },
      ) => {
        res[cur.level] = cur;
        return res;
      },
      {},
    );
    return { max_flow_pro, level_map };
  });

  const agentCommissionTotal = createMemo(() => {
    return (
      proxyAwardData().max_flow_pro +
      proxyAward2Data().max_flow_pro +
      teamRbateConfigData().max_flow_pro
    );
  });
  const agentAwardTotal = createMemo(() => {
    return (
      inviteConfigData().point +
      inviteBoxConfigData().total_point +
      inviteUsersVipData().total_point
    );
  });
  const inviteeRewardPoint = createMemo(() => {
    const pid = userStore.userInfo?.pid;
    const friend_reward: { reward: { point: number } } = affiliateStore
      .teamAgentDetails?.details?.invite_details?.friend_reward || {
      reward: { point: 0 },
    };
    const point = friend_reward.reward?.point;
    return pid &&
      !affiliateStore.teamAgentDetails.details.invite_details
        ?.received_invited_reward
      ? point || inviteConfigData().min_point
      : 0;
  });
  const inviteUsersData = createMemo(() => {
    if (getActivityState(ActivityTypeEnum.inviteUsers)) {
      const awards =
        getActivityCfg(ActivityTypeEnum.inviteUsers)?.cfg?.awards || [];
      const max_point = awards.reduce(
        (max: number, item: { reward: { point: number } }) => {
          const point = item.reward?.point || 0;
          return Math.max(max, point);
        },
        0,
      );
      return { max_point };
    }
    return { max_point: 0 };
  });
  const totalInviteRewards = createMemo(() => {
    return (
      inviteConfigData().point +
      inviteBoxConfigData().total_point +
      inviteUsersData().max_point
    );
  });
  const disRecharge3Data = createMemo(() => {
    if (getActivityState(ActivityTypeEnum.disRecharge3)) {
      const reward_items =
        getActivityCfg(ActivityTypeEnum.disRecharge3)?.cfg.reward_items || [];
      let max_point = 0;
      reward_items.forEach(
        (el: {
          parent_first_reward?: { point: number };
          parent_second_reward?: { point: number };
          parent_third_reward?: { point: number };
        }) => {
          if (
            el.parent_first_reward &&
            el.parent_first_reward.point > max_point
          ) {
            max_point = el.parent_first_reward.point;
          }
          if (
            el.parent_second_reward &&
            el.parent_second_reward.point > max_point
          ) {
            max_point = el.parent_second_reward.point;
          }
          if (
            el.parent_third_reward &&
            el.parent_third_reward.point > max_point
          ) {
            max_point = el.parent_third_reward.point;
          }
        },
      );
      return { max_point };
    }
    return { max_point: 0 };
  });
  const faqList = createMemo(() => {
    const list = [
      {
        value: 1,
        title: t("affiliate.whatIsProgram", {
          val: appName(),
        }),
        content: t("affiliate.programDescription", {
          val: appName(),
        }),
      },
      {
        value: 2,
        title: t("affiliate.costToParticipate"),
        content: t("affiliate.costFree"),
      },
    ];
    if (agentCommissionTotal()) {
      list.push({
        value: 3,
        title: t("affiliate.howMuchEarn"),
        content: t("affiliate.revenueShare", {
          val: agentCommissionTotal() / 100 + `%`,
        }),
      });
    }
    list.push({
      value: 4,
      title: t("affiliate.betterBenefits"),
      content: t("affiliate.exclusivePerks", {
        val: appName(),
      }),
    });
    return list;
  });
  const shareUrl = createMemo(() => {
    if (!affiliateStore.shareLink) {
      return "";
    }
    if (affiliateStore.shareLink && affiliateStore.shareLink.includes("http")) {
      return affiliateStore.shareLink;
    }
    const domain = window.location.origin;
    return domain + affiliateStore.shareLink;
  });
  const shareCode = createMemo(() => {
    const uid = userStore.userInfo?.uid;
    return affiliateStore.code || uid;
  });
  const tabList = () => {
    const list: AffiliateTabItem[] = [
      {
        value: "dashboard",
        text: t("affiliate.dashboard"),
        icon: "general/dashboard",
      },
    ];
    if (inviteeRewardPoint()) {
      list.push({
        value: "invitee-rewards",
        text: t("affiliate.invitee_rewards"),
        icon: "general/rules",
        showRedDot: affiliateStore.agentFriendShowCount,
      });
    }
    list.push({
      value: "my-rewards",
      text: t("affiliate.my_rewards"),
      icon: "general/my_rewards",
      showRedDot: affiliateStore.agentShowCount,
    });
    if (
      (affiliateStore.teamAgentAllConfig.cfg?.invite_config?.status == 1 ||
        affiliateStore.teamAgentAllConfig.cfg?.invite_box_config?.status == 1 ||
        getActivityState(ActivityTypeEnum.inviteUsersVip)) &&
      !isLabelHideAgentActivity()
    ) {
      list.push({
        value: "invitation-rewards",
        text: t("affiliate.invitation_rewards"),
        icon: "general/invitation",
      });
    }
    list.push({
      value: "rules",
      text: t("affiliate.rules"),
      icon: "general/rule",
    });
    return list;
  };
  // const mediaShareList = createMemo(() => {
  //   //默认的
  //   const list: {
  //     icon: string;
  //     url?: string;
  //     name: string;
  //     appUrl?: string;
  //     ipatype?: number;
  //   }[] = [
  //     {
  //       url: "http://www.facebook.com/sharer/sharer.php?u={url}",
  //       icon: "sociality/c_facebook",
  //       name: "Facebook",
  //       appUrl: "fb://share/?link={url}",
  //       ipatype: ipatypeEnum.facebook,
  //     },
  //     {
  //       url: "https://telegram.me/share/url?url={url}&text={text}",
  //       icon: "sociality/c_telegram",
  //       name: "Telegram",
  //       ipatype: ipatypeEnum.telegram,
  //     },
  //     {
  //       url: "https://api.whatsapp.com/send?text={text}  {url}",
  //       icon: "sociality/c_whatsapp",
  //       name: "Whatsapp",
  //       ipatype: ipatypeEnum.whatsapp,
  //     },
  //     {
  //       url: "https://bsky.app/share?text=${text}&url=${url}",
  //       icon: "sociality/c_bluesky",
  //       name: "bluesky",
  //       ipatype: ipatypeEnum.bluesky,
  //     },
  //     {
  //       url: "https://s.kw.ai",
  //       icon: "sociality/c_technology",
  //       name: "Kwai",
  //       appUrl: "kwai://messages/",
  //       ipatype: ipatypeEnum.kwai,
  //     },
  //     {
  //       url: "https://www.instagram.com",
  //       icon: "sociality/c_instagra",
  //       name: "Instagram",
  //       appUrl: "instagram://direct-inbox",
  //       ipatype: ipatypeEnum.ins,
  //     },
  //     {
  //       url: "https://www.tiktok.com",
  //       icon: "sociality/c_tiktok",
  //       name: "TikTok",
  //       appUrl: "snssdk1233://feed",
  //       ipatype: ipatypeEnum.tiktok,
  //     },
  //     {
  //       icon: "more",
  //       name: "More",
  //     },
  //   ];
  //   return configStore.frontCfgMap["AffiliateConfig"]?.shareMediaList || list;
  // });
  const teamFriendsReward = createMemo(() => {
    interface FriendReward {
      reward_recv_cond: {
        need_agent_vaild: boolean;
        need_bind_cpf: boolean;
        bind_cpf_status: boolean;
        need_bind_phone: boolean;
        bind_phone_status: boolean;
        need_bind_withdraw_account: boolean;
        bind_withdraw_account_status: boolean;
      };
      is_receivable: boolean;
      act_type: number;
      id: string;
    }
    const friend_reward =
      affiliateStore.teamAgentDetails?.details?.invite_details?.friend_reward ||
      ({} as FriendReward);
    return friend_reward;
  });
  const rebateCalculator = createMemo(() => {
    return (affiliateStore.rebateValue1 * affiliateStore.rebateValue2) / 100;
  });
  const contactData = createMemo(() => {
    // [
    //   { text: "Telegrame:@BET5G_AGENTE1", url: "https://t.me/aly161723" },
    // ]; //范例
    const list = configStore.frontCfgMap["AffiliateConfig"]?.contactList || [];
    return { list };
  });
  const agentBaseConfig = createMemo(() => {
    const agent_base_config =
      sysConfigStore.sysConfigData.agent_base_config || {};
    const ignore_game_classes = agent_base_config.ignore_game_classes || [];
    const all_game_classes = [1, 2, 3, 4, 5, 6, 10];
    const result = all_game_classes.filter(
      (item) => !ignore_game_classes.includes(item),
    );
    const arr = result.map((item: any) => getGclassName(item.toString()));
    const typeStr = arr.join("、") || "";
    return {
      invite_cfg: agent_base_config.invite_cfg || {},
      typeStr,
    };
  });
  const shareImgList = createMemo(() => {
    const list = getContentByLang(affiliateStore.teamShareConfig.img_config);
    return list;
  });
  const shareTextList = createMemo(() => {
    const text: { text: string; text1: string; text2: string; text3: string } =
      getContentByLang(affiliateStore.teamShareConfig.text_config) || {};
    const list = [];
    if (text.text1) {
      list.push({ text: text.text1 });
    }
    if (text.text2) {
      list.push({ text: text.text2 });
    }
    if (text.text3) {
      list.push({ text: text.text3 });
    }
    return list;
  });
  const shareText = createMemo(() => {
    const text = shareTextList()[affiliateStore.activeShareText]?.text;
    return text;
  });
  const viplevelMaps = createMemo(() => {
    const levels = sysConfigStore.sysConfigData.vip_config?.levels || [];
    const map = {};
    levels.forEach((el: any) => {
      map[el.vip] = el;
    });
    return map;
  });
  const agentStyle = createMemo(() => {
    return configStore.frontCfgMap["AffiliateConfig"]?.style || 2;
  });
  return {
    inviteConfigData,
    inviteBoxConfigData,
    inviteUsersVipData,
    proxyAwardData,
    proxyAward2Data,
    teamRbateConfigData,
    agentCommissionTotal,
    agentAwardTotal,
    inviteUsersData,
    totalInviteRewards,
    disRecharge3Data,
    agentStyle,
    shareUrl,
    shareCode,
    faqList,
    inviteeRewardPoint,
    tabList,
    // mediaShareList,
    inviteBoxDetailsData,
    teamFriendsReward,
    rebateCalculator,
    contactData,
    agentBaseConfig,
    shareImgList,
    shareTextList,
    shareText,
    referralRewardsTotal,
    teamAgentInviteFriendsReward,
    teamAgentInviteBoxData,
    viplevelMaps,
    isLabelHideAgentActivity,
    isLabelHideAgentData,
  };
});
